export const images = {
  mev1: require("./mev1.png"),
  mev2: require("./mev2.png"),
  mev3: require("./mev3.png"),
  mevarmy: require("./mevarmy.png"),
  favicon: require("./favicon.ico"),
};
